import React from "react";
import { CompanionThreadsProvider } from "../contexts/CompanionThreadsContext";
import { ChatAudioPreferencesProvider } from "../contexts/ChatAudioPreferencesContext";
import CompanionAiDisclaimerGate from "../containers/companion/CompanionAiDisclaimerGate";

const withCompanionProviders = <Props extends object>(Component: React.ComponentType<Props>) => {
  const Wrapped = (props: Props) => (
    <CompanionThreadsProvider>
      <ChatAudioPreferencesProvider>
        <CompanionAiDisclaimerGate>
          <Component {...props} />
        </CompanionAiDisclaimerGate>
      </ChatAudioPreferencesProvider>
    </CompanionThreadsProvider>
  );

  const componentName = Component.displayName ?? Component.name ?? "Component";
  Wrapped.displayName = `withCompanionProviders(${componentName})`;

  return Wrapped;
};

export default withCompanionProviders;
